import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationBell from "./NotificationBell";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAuthed = user && typeof user === "object";

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="sb-navbar" data-testid="app-navbar">
      <div className="container d-flex align-items-center py-3">
        <Link to="/" className="sb-brand-wrap text-decoration-none" data-testid="nav-brand" aria-label="InstaVivah home">
          <img
            src="https://customer-assets-v7afamib.emergentagent.net/job_vivah-deploy-test/artifacts/ixq288yn_instavivah.png"
            alt="InstaVivah"
            className="sb-brand-logo"
          />
        </Link>

        <div className="ms-auto d-flex align-items-center gap-2 gap-md-3">
          <NavLink
            to="/biodata/build"
            className={({ isActive }) =>
              "sb-link-quiet d-none d-md-inline" + (isActive ? " fw-semibold" : "")
            }
            data-testid="nav-build"
          >
            Build Biodata
          </NavLink>

          <NavLink
            to="/browse"
            className={({ isActive }) =>
              "sb-link-quiet d-none d-md-inline" + (isActive ? " fw-semibold" : "")
            }
            data-testid="nav-browse"
          >
            Browse Profiles
          </NavLink>

          <NavLink
            to="/templates"
            className={({ isActive }) =>
              "sb-link-quiet d-none d-lg-inline" + (isActive ? " fw-semibold" : "")
            }
            data-testid="nav-templates"
          >
            Templates
          </NavLink>

          {isAuthed ? (
            <>
              <NavLink
                to="/search"
                className={({ isActive }) =>
                  "sb-link-quiet d-none d-md-inline" + (isActive ? " fw-semibold" : "")
                }
                data-testid="nav-search"
              >
                Search
              </NavLink>
              <NavLink
                to="/profile/edit"
                className={({ isActive }) =>
                  "sb-link-quiet d-none d-md-inline" + (isActive ? " fw-semibold" : "")
                }
                data-testid="nav-profile"
              >
                My Profile
              </NavLink>
              <NavLink
                to="/interests"
                className={({ isActive }) =>
                  "sb-link-quiet d-none d-md-inline" + (isActive ? " fw-semibold" : "")
                }
                data-testid="nav-interests"
              >
                Interests
              </NavLink>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  "sb-link-quiet d-none d-lg-inline" + (isActive ? " fw-semibold" : "")
                }
                data-testid="nav-dashboard"
              >
                Dashboard
              </NavLink>
              {user.role === "admin" && (
                <NavLink
                  to="/admin/payments"
                  className={({ isActive }) =>
                    "sb-link-quiet d-none d-lg-inline" + (isActive ? " fw-semibold" : "")
                  }
                  data-testid="nav-admin"
                >
                  Admin
                </NavLink>
              )}
              {user.membership !== "premium" && (
                <NavLink
                  to="/premium"
                  className="btn btn-gold btn-sm"
                  data-testid="nav-upgrade"
                >
                  Upgrade
                </NavLink>
              )}
              <NotificationBell />
              <span className="sb-badge-soft d-none d-sm-inline" data-testid="nav-membership">
                {user.membership === "premium" ? "Premium" : "Free"}
              </span>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={onLogout}
                data-testid="nav-logout"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <NavLink
                to="/login"
                className="sb-link-quiet d-none d-sm-inline"
                data-testid="nav-login"
              >
                Login
              </NavLink>
              <Link to="/register" className="btn btn-primary btn-sm" data-testid="nav-register">
                Create profile
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
